import { render, staticRenderFns } from "./FactoringConfirm.vue?vue&type=template&id=996c7aca&"
import script from "./FactoringConfirm.vue?vue&type=script&lang=js&"
export * from "./FactoringConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports